import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, editAllowance } from 'src/reducers/clients/allowances';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getItem, setItem, getItemErrors, setItemExtra, getItemExtra } from 'src/reducers/common/itemReducer';
import AllowanceEditingForm from './components/AllowanceEditingForm';
import { useTranslation } from 'react-i18next';

const initializeClientAllowanceItemId = (clientAllowanceItems) =>
  clientAllowanceItems.map((clientAllowanceItem) => (clientAllowanceItem.value ? clientAllowanceItem.id : false));

let EditAllowanceForm = reduxForm({
  form: CLIENT_ALLOWANCE_FORM,
})(AllowanceEditingForm);

const mapStateToProps = (state) => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    allowanceAmount:
      getItem(REDUCER_NAME, state) && getItem(REDUCER_NAME, state).allowanceAmount
        ? getItem(REDUCER_NAME, state).allowanceAmount
        : '0',
    clientAllowanceItemId: initializeClientAllowanceItemId(getSelectOptions(state, 'clientAllowanceItems'))
  },
  isUsedPayment: getItemExtra(REDUCER_NAME, state).isUsedPayment || false
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data) => {
    dispatch(editAllowance(data));
  },
});

EditAllowanceForm = connect(mapStateToProps, mapDispatchToProps)(EditAllowanceForm);

const EditClientAllowance = ({ dispatch, values, extras, match, payrollRulesGroup, motivation, clientAllowanceItemIds }) => {
  const { t } = useTranslation();
  const { payrollRulesGroupId } = match.params;

  const dispatchOptions = motivation

    ? {
        motivationId: motivation.id,
        motivationStep: motivation.motivationStep ? JSON.parse(motivation.motivationStep): [],
        probationStep: motivation.probationStep ? JSON.parse(motivation.probationStep) : [],
        clientAllowanceItemIds: clientAllowanceItemIds,
      }
    : {
      motivationStep: [],
      probationStep: []
    };

  dispatch(
    setItem(REDUCER_NAME, {
      ...values,
      ...motivation,
      id: values.id,
      motivationState: 'fulltime',
      ...dispatchOptions,
    })
  );
  dispatch(setItemExtra(REDUCER_NAME, extras));
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">
          {t('features.ClientAllowances.EditClientAllowance.provision_deduction_items_edit')}
        </h1>
        <div className="m-title-main-note">{payrollRulesGroup.name}</div>
      </div>
      <div className="l-wrap-m">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item
              label={t('features.ClientAllowances.EditClientAllowance.setting')}
              path={CLIENT_SETTINGS}
            />
            <BreadCrumb.Item
              label={t('features.ClientAllowances.EditClientAllowance.salary_rule_group_list')}
              path={CLIENT_PAYROLL_RULES_GROUP_LIST}
            />
            <BreadCrumb.Item
              label={t('features.ClientAllowances.EditClientAllowance.provision_deduction_items_list')}
              path={`/clients/payroll_rules_groups/${payrollRulesGroupId}/allowances`}
            />
            <BreadCrumb.Item
              label={t('features.ClientAllowances.EditClientAllowance.provision_deduction_items_edit')}
            />
          </BreadCrumb>
        </div>
        <EditAllowanceForm payrollRulesGroup={payrollRulesGroup} />
      </div>
    </div>
  );
};
export default connect()(EditClientAllowance);
